module.exports = __webpack_public_path__ + "static/media/IAS.75b5bdd8.png";